import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Popover, Overlay } from 'react-bootstrap';
import cn from 'classnames';

import { Button } from 'components/Button';
import './styles.scss';

const PopoverCheckbox = (props) => {
  const { isChecked, onChange, className, errorMessage, isDisabled, type, label, name, id, value, children, title } = props;
  const [show, setShow] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [target, setTarget] = useState(null);

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop < e.target.getBoundingClientRect().height + 50;
    if (bottom) {
      setIsButtonDisabled(false);
    }
  };

  const handleChange = (e) => {
    if (isChecked) {
      onChange(false);
    } else {
      setTarget(e.target);
      setShow(!show);
    }
  };

  const handleAcceptButton = (e) => {
    e.preventDefault();
    if (isDisabled) return false;

    onChange(type === 'checkbox' ? !isChecked : value);
    setShow(false);
  };

  const popoverClick = () => (
    <Popover id={`${id}-wrapper`} className="popover" title={title}>
      <div className="scrollBar" onScroll={handleScroll}>
        {children}
      </div>
      <div className="small-12" style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          className={cn('button small blue', 'button')}
          onClick={handleAcceptButton}
          isDisabled={props.isButtonDisabled && isButtonDisabled}
        >
          I Agree
        </Button>
      </div>
    </Popover>
  );

  return (
    <div className="popover-checkbox">
      <div className="popover-checkbox-container">
        <div className="checkbox">
          <Overlay
            show={show}
            target={target}
            placement="top"
            containerPadding={20}
            rootClose
            onHide={() => { setShow(false); }}
          >
            {popoverClick()}
          </Overlay>
          <input
            className="input"
            type={type}
            name={name}
            onChange={handleChange}
            checked={isChecked}
            id={id}
          />
          <label className={cn(className, 'label')} htmlFor={id}>
            {label.map((item, index) => <Fragment key={index}>{item}</Fragment>)}
          </label>
        </div>
        {!!errorMessage && <div className="error">{errorMessage}</div> }
      </div>
    </div>
  );
};

PopoverCheckbox.propTypes = {
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.array,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  isButtonDisabled: PropTypes.bool,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PopoverCheckbox.defaultProps = {
  onChange: () => {},
  isChecked: false,
  isDisabled: false,
  label: [],
  name: '',
  type: 'checkbox',
  value: 'on',
  className: '',
  errorMessage: '',
  isButtonDisabled: true,
  title: 'Merchant Agreement',
};

export default PopoverCheckbox;
